import { Settings } from '../settings';

class RGSProvider {
  static async loadProvider() {
    if (!Settings.APP || !Settings.APP.RGS_PROVIDER) {
      console.log(Settings);
      throw new Error('RGS Provider not specified in Settings.');
    }

    const providerName = Settings.APP.RGS_PROVIDER;

    try {
      const providerClass = (await import(`./${providerName}/${providerName}`)).default;
      return new providerClass();
    } catch (error) {
      throw new Error(`RGS Provider '${providerName}' not found: ${error.message}`);
    }
  }
}

export default RGSProvider;
